import { render, staticRenderFns } from "./ConfirmDeleteInsuranceForm.vue?vue&type=template&id=6faa6f66"
import script from "./ConfirmDeleteInsuranceForm.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteInsuranceForm.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteInsuranceForm.vue?vue&type=style&index=0&id=6faa6f66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports